// 引入查询
const Query = () => import(/* webpackChunkName: "group-foo" */ './pages/query')
// 引入用户页面
const QueryDetail = () => import(/* webpackChunkName: "group-foo" */ './pages/queryDetail')
const noVisit = () => import(/* webpackChunkName: "group-foo" */ './pages/noVisit')
const routerConfig = [
  {
    path: '/',
    redirect: '/query'
  },
  {
    path: '/query',
    name: '优先邮查件',
    component: Query,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/queryDetail/:mailNo',
    name: '',
    component: QueryDetail,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/noVisit',
    name: '优先邮查件',
    component: noVisit,
    meta: {
      keepAlive: false
    }
  }
]

export default routerConfig
